import { useState } from "react";
import { any } from "../../regex/REGEX";
import { IoInformationCircleOutline } from "react-icons/io5";
import { Tooltip } from "react-tooltip";
import "./textInput.css";
import { replaceAt } from "../../util/util";
import { HiOutlineExternalLink } from "react-icons/hi";

function TextInput({
    label = null,
    field,
    value,
    validRegex = any,
    allowRegex = undefined,
    tooltipMessage,
    updateStateField,
    docsLink = null,
    placeholder = null,
}) {
    const [isValid, setValid] = useState(true);
    const [getInputValue, setInputValue] = useState("");
    const [getInvalidInputMessage, setInvalidInputMessage] = useState("");

    const handleChange = (input) => {
        let value = input.target.value;

        if (allowRegex) {
            // remove any not allowed characters
            for (let i = 0; i < value.length; i++) {
                if (!value.charAt(i).match(allowRegex)) {
                    value = replaceAt(value, i, "")
                    i-- //compensate index for removed char
                }
            }
        }

        if (value.match(validRegex)) {
            setValid(true);

            switch (field) {
                case "outfile":
                    updateStateField(field, value);
                    break;
                default:
                    if (value.includes(".")) {
                        // if decimal digits exist parse with .toFixed to preserve trailing zeros
                        // we do not need to test for 0 here as .toFixed returns a string
                        value = parseFloat(value).toFixed(value.split(".")[1].length) || undefined;
                    } else if (value === "") {
                        value = "";
                    } else {
                        //we do need to test for 0 with isNaN() here as the logical OR operator (||) considers the number value 0 falsey
                        value = !isNaN(parseFloat(value)) ? parseFloat(value) : undefined;
                    }

                    updateStateField(field, value);
                    break;
            }
        } else {
            /*
            if the input is not valid the input field will display the getInputValue instead of the state value
            this is to avoid having the state variable be set to an invalid value and also still allow input of invalid values
            blocking any invalid input leads to bad UX
            */
            setInputValue(value || "");
            setValid(false);
            setInvalidInputMessage("not a valid input");
        }
    };

    const handleLeave = () => {
        if (field !== "outfile" && field !== "radtopo_radius") {
            updateStateField(field, !isNaN(parseFloat(value)) ? parseFloat(value) : "")
        }
    };

    return (
        <div className={"input-container"}>
            <Tooltip id={"info-tooltip"} />
            <div className={"label-container"}>
                <p
                    onClick={docsLink ? () => window.open(docsLink) : null}
                    className={docsLink ? "label has-hyperlink" : "label"}
                >
                    {label ?? field}
                    {docsLink &&
                        <HiOutlineExternalLink className={"external-link-icon"} />
                    }
                </p>
                <IoInformationCircleOutline
                    data-tooltip-id={"info-tooltip"}
                    data-tooltip-place={"right"}
                    data-tooltip-content={tooltipMessage}
                />
            </div>
            <input
                style={isValid ? null : { border: "1px solid var(--warning-color)" }}
                onBlur={handleLeave}
                value={
                    isValid ? value : getInputValue
                }
                type={"text"}
                className="text-input"
                onChange={handleChange}
                placeholder={placeholder ?? field}
            />
            {!isValid && (
                <p className={"invalid-input-message"}>{getInvalidInputMessage}</p>
            )}
        </div>
    );
}

export default TextInput;
